import { Container } from './styles';
import { GanttTimeLine } from '../../../components/GanttTimeLine/index';
import Modal from '../../../components/general/Modal/index';

//? Confirm Copy modal:
//isOpen -> Controlador se o modal está aberto ou não
//onClose -> Função executada ao cancelar/fechar/clicar fora do modal
//onConfirm -> Função executada ao confirmar no modal
//selector -> Local onde o modal sera renderizado(root -> Toda a tela)
//className -> nodrag = modal não pode ser movido

const GanttModal = ({ isOpen, onClose, selector, className }) => {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      selector={selector}
      className={className}
    >
      <Container>
        <GanttTimeLine />
      </Container>
    </Modal>
  );
};

export default GanttModal;
